// frontend/src/i18n/es.js

/**
 * Diccionario de traducciones en español.
 * Clave: texto original, Valor: texto traducido en español.
 */
export default {
  "# Members": "# Miembros",
  "(provide a valid email)": "(proporcione una dirección válida)",
  "(provide a valid phone)": "(proporcione un teléfono válido)",
  "Add member": "Añadir miembro",
  "Access code": "Código de acceso",
  "Access code not found": "Código de acceso n o encontrado",
  "Age": "Edad",
  "Actions": "Acciones",
  "Add Member": "Agregar Miembro",
  "All fields are required.": "Todos los campos son obligatorios.",
  "Another person matches the same identity fingerprint": "Otra persona coincide con la misma huella dactilar de identidad",
  "Apply": "Aplicar",
  "Are you sure you want to exclude": "¿Estás seguro de excluir a",
  "Are you sure you want to permanently delete the group": "¿Estás seguro de que deseas eliminar de forma permanente el grupo",
  "Back": "Regresar",
  "Back to dashboard": "Regresar al Panel de Control",
  "Back to invitations": "Regresar a invitaciones",
  "Birthdate": "Fecha de Nacimiento",
  "Block": "Bloquear",
  "Blocked": "Bloqueada",
  "Cancel": "Cancelar",
  "Change group": "Cambiar de grupo",
  "Clear": "Limpiar",
  "Close": "Cerrar",
  "Close group": "Cerrar grupo",
  "Confirm": "Confirmar",
  "Confirm Deletion": "Confirmar eliminación",
  "Contact": "Contacto",
  "Contact name": "Nombre del contacto",
  "Contact the group leader to make changes.": "Contacta al líder del grupo para realizar cambios.",
  "Contactable via WhatsApp": "Contactar via WhatsApp",
  "Copy link": "Copiar enlace",
  "Could not save the changes.": "No se pudieron guardar los cambios.",
  "Create": "Crear",
  "Create invitation": "Crear invitación",
  "Create new group": "Crear nuevo grupo",
  "Create new invitation": "Generar nueva invitación",
  "Created": "Fecha creación",
  "Created At (female)": "Creada el",
  "Created At (male)": "Creado el",
  "Creating...": "Creando...",
  "Delete": "Eliminar",
  "Delete Group": "Eliminar Grupo",
  "Delete invitation": "Eliminar invitación",
  "Edit": "Editar",
  "Edit group": "Editar Grupo",
  "Edit group information": "Editar información del grupo",
  "Email": "Correo electrónico",
  "Email address is missing.": "Falta la dirección de correo electrónico.",
  "Email channel will be enabled only if a valid email is present.": "El canal de correo electrónico se habilitará solo si hay un correo electrónico válido.",
  "Enter": "Ingresar",
  "Enter access code": "Indique código de acceso",
  "Enter it here": "Ingresa tu código aquí",
  "Enter phone number": "Ingrese número",
  "Error blocking group": "Error bloqueando el grupo",
  "Error creating group": "Error creando grupo",
  "Error deleting group. Please try again.": "Error al eliminar el grupo. Inténtalo de nuevo.",
  "Error loading invitations": "Error al cargar las invitaciones",
  "Error unlocking group": "Error desbloqueando el grupo",
  "Error updating invitation status": "Error al actualizar el estado de la invitación",
  "Export to Excel": "Exportar a Excel",
  "Failed to create invitation.": "No se pudo generar la invitación.",
  "Failed to create member": "No se pudo registrar la persona",
  "Failed to send magic link. Please try again.": "Fallo al enviar el enlace de acceso. Por favor intente de nuevo.",
  "Female": "Femenino",
  "Filters": "Filtros",
  "Filters applied": "Filtros aplicados",
  "First / Middle Name": "Nombre / Segundo nombre",
  "First Name": "Primer Nombre",
  "Full Last Name": "Apellidos",
  "Full Name": "Nombres",
  "Gender": "Género",
  "Group Access": "Acceso al Grupo",
  "Group Invitations": "Invitaciones del grupo",
  "Group Name": "Nombre del Grupo",
  "Group owner": "Líder del grupo",
  "Have an access code instead?": "¿Tienes un código de acceso?",
  "Have an account?": "¿Tienes una cuenta?",
  "Hash": "Hash",
  "In the form, use the authentication code you received.": "En el formulario, use el código de autenticación que recibió.",
  "internal": "Interna",
  "Invalid credentials": "Credenciales inválidas",
  "Invalid email format.": "El formato del correo no es válido.",
  "Invalid hash": "Hash inválido",
  "Invalid or expired link. Please try again.": "Enlace inválido o expirado. Intente de nuevo.",
  "Invalid or mismatched data.": "Datos no válidos o no coincidentes.",
  "Invalid or unauthorized hash": "Hash no válido o no autorizado",
  "Invitation created and email sent.": "Se ha creado la invitación y se envió la notificación.",
  "Invitation email sent successfully": "Correo de invitación enviado con éxito",
  "Last Name": "Primer Apellido",
  "Last Name(s)": "Apellido / Segundo Apellido",
  "Lock group": "Bloquear grupo",
  "Log in": "Iniciar sesión",
  "Login": "Inicio de sesión",
  "Logout": "Cerrar Sesión",
  "Loading members...": "Cargando miembros...",
  "Access link sent. Tell the group owner to check their email.": "Enlace de acceso enviado. Dile al responsable del grupo que revise su correo electrónico",
  "Male": "Masculino",
  "Manage Members": "Gestionar Miembros",
  "Middle Name": "Segundo Nombre",
  "My Groups": "Mis Grupos",
  "Name": "Nombre",
  "Name is required and at least one contact method (phone or email) is required.": "Se requiere nombre y al menos un método de contacto (teléfono o correo electrónico).",
  "National ID": "Cédula",
  "Nationality": "Nacionalidad",
  "Next": "Próxima",
  "No active session": "Sin sesión activa",
  "No name": "Sin nombre",
  "No phone": "Sin teléfono",
  "Notify by email": "Notificar por correo electrónico",
  "Notify by WhatsApp": "Notificar por WhatsApp",
  "Only Dominican ID numbers are accepted. They must contain exactly 11 digits and pass the official checksum validation. If this is not possible, please use a valid passport instead.": "Solo se permiten cédulas dominicanas. Deben tener exactamente 11 dígitos y pasar la validación de dígito verificador. Si no es posible, utilice un pasaporte válido.",
  "Or, receive an access link via email:": "O, reciba un enlace de acceso por correo electrónico",
  "Page": "Pág.",
  "Passport": "Pasaporte",
  "Person already registered in this group": "Persona ya registrada en este grupo",
  "Phone": "Teléfono",
  "Phone must contain at least 7 digits.": "El teléfono debe tener al menos 7 dígitos.",
  "Please check the format and try again": "Verifique el formato e intente de nuevo",
  "Please enter a valid phone number.": "Por favor indique un número de teéfono válido",
  "Please enter your access code": "Indique su código de acceso",
  "Please enter your email or phone": "Indique su correo electrónico o teléfono",
  "Prev": "Anterior",
  "Reactivate": "Reactivar",
  "Recipient": "Dirección",
  "Reopen group": "Reabrir grupo",
  "Resend email": "Reenviar notificación",
  "Resend invitation email": "Reenviar correo de Invitación",
  "Responsible": "Responsable",
  "Responsible Email": "Correo Electrónico del Responsable",
  "Responsible Name": "Nombre del Responsable",
  "Responsible Phone": "Teléfono del Responsable",
  "Revoke Invitation": "Revocar invitación",
  "Revoked": "Revocada",
  "Save": "Guardar",
  "Second Last Name": "Segundo Apellido",
  "Send a copy to the leader": "Enviar una copia al líder",
  "Send Magic Link": "Enviar un enlace de acceso",
  "Sign in here": "Accede aqui",
  "Status": "Estado",
  "Switch to dark mode": "Cambiar a modo oscuro",
  "Switch to English": "Switch to English",
  "Switch to light mode": "Cambiar a modo claro",
  "Switch to Spanish": "Cambiar a Español",
  "The country configuration is missing. Please contact support or your system administrator.": "Falta la configuración del país. Por favor, contacte con soporte o con el administrador del sistema.",
  "This action is irreversible and will delete all its members and invitations.": "Esta acción es irreversible y eliminará a todos sus miembros e invitaciones.",
  "This age exceeds contractual policies.": "La  edad excede las políticas contractuales.",
  "This field is required.": "Este campo es obligatorio",
  "This group is closed.": "Este grupo está cerrado",
  "This group is in read-only mode.": "Este grupo es de solo lectura.",
  "To delete this invitation permanently, type": "Para eliminar esta invitación permanentemente, escriba",
  "Token not provided. Redirecting...": "Token no suministrado. Redirigiendo...",
  "Total Groups": "Grupos",
  "Total Members": "Personas",
  "Total People": "Total de Personas",
  "Travel Group": "Grupo de Viaje",
  "Unable to load your groups.": "No fue posible cargar tus grupos.",
  "Unblock": "Desbloquear",
  "Unexpected error during access verification": "Error inesperado durante la verificación de acceso",
  "Unexpected error. Please try again": "Error inesperado. Intente de nuevo",
  "Unknown error.": "Error desconocido.",
  "Unnamed group": "Grupo sin nombre",
  "Validating...": "Verificando...",
  "Validating your access link...": "Validando su enlace de acceso...",
  "Verified member — Editing is restricted (only Contact & Passport).": "Miembro verificado - Edición restringida (solo Pasaporte y Contacto).",
  "View members": "Ver miembros",
  "WhatsApp channel will be enabled only if a valid phone is present.": "El canal de WhatsApp se habilitará solo si hay un teléfono válido.",
  "Yes, Delete": "Si, Eliminar",
  "You must enter the group name and phone number.": "Debe ingresar el nombre del grupo y el número de teléfono.",
  "You will be redirected shortly.": "Usted será redireccionado en breve.",
  "Your email or phone": "Correo electrónico o teléfono",
  "active": "activa",
  "active (female)": "activa",
  "active (male)": "activo",
  "blocked": "bloqueado",
  "blocked (female)": "bloqueada",
  "blocked (male)": "bloqueado",
  "closed": "cerrado",
  "closed (female)": "cerrada",
  "closed (male)": "cerrado",
  "from the group?": "de este grupo?",
  "null": "n/d",
  "null (female)": "n/d",
  "null (male)": "n/d",
  "of": "de",
  "pending (male)": "pendiente",
  "revoked": "revocada",
  "revoked (female)": "revocada",
  "revoked (male)": "revocado",
  "years": "años",
  "yrs": "años",
  "{{count}} member": "{{count}} miembro",
  "{{count}} members": "{{count}} miembros"
}
